export class APIError {
  public name = 'APIError';
  public message: string;
  public status: number;
  public endpoint: string;
  public cause?: unknown;

  constructor(details: {
    status: number;
    message: string;
    endpoint: string;
    cause?: unknown;
  }) {
    this.message = details.message;
    this.status = details.status;
    this.endpoint = details.endpoint;
    this.cause = details.cause;
  }
}

export interface APIErrorResponse {
  message: string;
  code?: string;
}
